;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('inputDropdownMultiple', inputDropdownMultiple)

  /* @ngInject */
  function inputDropdownMultiple () {
    return {
      restrict: 'E',
      scope: {
        label: '@',
        placeholder: '@',
        modelPropertyName: '@',
        options: '<',
        model: '=',
        value: '<',
        disabled: '<',
        loading: '<',
        change: '=',
        description: '@'
      },
      templateUrl: '/core/directives/input-dropdown-multiple/input-dropdown-multiple-directive.html?$$REVISION$$',
      controller: 'InputDropdownMultipleController'
    }
  }
})()
